<div class="modal" id="editPermissions" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="dcf-wrapper dcf-pt-8 dcf-pb-5">
    <h4>Edit Permissions</h4>
    <form id="edit--permissions-form">
      <fieldset>
        @for (permission of data.permissions; track permission) {
          <div>
            <!-- <input type="text" name="email" [(ngModel)]="data.user.email" class="dcf-input-text form-control" id="email" placeholder="student@huskers.unl.edu" required> -->
            <input type="checkbox" [name]="permission.lookupName" [(ngModel)]="permission.userPermissionId" [id]="'permissionId'+permission.permissionId">
            <label [for]="'permissionId'+permission.permissionId">{{ permission.name }}</label>
          </div>
        }
      </fieldset>
      <div class="dcf-pt-5">
        <button type="submit" class="dcf-btn dcf-btn-primary" (click)="save()">Save User</button>
        <button type="button" class="dcf-btn dcf-btn-secondary close-modal-button" (click)="close()">Close</button>
      </div>
    </form>
  </div>
</div>